import { ResolverTag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import useOpenWindow from '@swf/core/hooks/useOpenWindow';

import Prompt from '../../Prompt/Prompt';

import {
  TXTACL_Contact_us,
  TXTWCL_Bank_Wire_Transfer_1,
  TXTWCL_Deposit_another_way,
  TXTWCL_The_minimum_deposit_amount_is__ELL,
  TXTWCL_To_verify_your_account_and_rec_ELL,
  TXTWCL_You_may_need_to_verify_your_ac_ELL
} from './WbtBankNotAvailable.messages.json';
import { text } from './WbtBankNotAvailable.scss';

interface Props {
  onClose(): void;
}

const minimumDepositAmount = '$5000';

const WbtBankNotAvailable: React.FC<Props> = ({ onClose }) => {
  const openWindowContactSupport = useOpenWindow({
    resolverTag: ResolverTag.ContactSupportCashierTroubleDeposit,
    centered: true
  });

  return (
    <Prompt
      onClose={onClose}
      variant="warning"
      title={{
        translation: { ...TXTWCL_Bank_Wire_Transfer_1 }
      }}
      primaryButton={{ translation: TXTACL_Contact_us }}
      secondaryButton={{
        translation: TXTWCL_Deposit_another_way
      }}
      onPrimaryButtonClick={openWindowContactSupport}
    >
      <div className={text}>
        <Translation
          {...TXTWCL_The_minimum_deposit_amount_is__ELL}
          values={{ 0: minimumDepositAmount }}
        />
      </div>
      <div className={text}>
        <Translation {...TXTWCL_You_may_need_to_verify_your_ac_ELL} />{' '}
        <Translation {...TXTWCL_To_verify_your_account_and_rec_ELL} />
      </div>
    </Prompt>
  );
};

export default WbtBankNotAvailable;
